// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA2mh63uFNsM2shsuFBlFl0lE1bvfvqNrk",
  authDomain: "united-for-her.firebaseapp.com",
  databaseURL: "https://united-for-her.firebaseio.com",
  projectId: "united-for-her",
  storageBucket: "united-for-her.appspot.com",
  messagingSenderId: "813716010162",
  appId: "1:813716010162:web:4f049a9ecd8f9c2d1545ab",
  measurementId: "G-1SPV63X0XH"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const storage = getStorage(app);

export default app;
 